module.exports = __webpack_public_path__ + "static/prize-game-min-8bca9113246da7686bd10619cd54f6a0.png";